import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import axiosInstance from "../../../../services/AxiosInstance";

const DAYS_OF_WEEK = [
    ['MONDAY', 'Segunda-feira'], ['TUESDAY', 'Terça-feira'],
    ['WEDNESDAY', 'Quarta-feira'], ['THURSDAY', 'Quinta-feira'],
    ['FRIDAY', 'Sexta-feira'], ['SATURDAY', 'Sábado'], ['SUNDAY', 'Domingo']
];

const defaultDay = (branchId, [dayOfWeek, dayLabel]) => ({
    branchId, dayOfWeek, dayLabel, isOpen: dayOfWeek !== 'SUNDAY',
    openTime: '08:00', closeTime: dayOfWeek === 'SATURDAY' ? '12:00' : '18:00',
    breakStartTime: null, breakEndTime: null
});

/** Editor incorporado ao cadastro da filial; mantém a mesma API do editor antigo. */
const BranchWorkingHoursEditor = ({ branchId, onChange }) => {
    const { t } = useTranslation();
    const [workingHours, setWorkingHours] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const load = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`/main/branch-working-hours/branch/${branchId}`);
            setWorkingHours(DAYS_OF_WEEK.map(day => {
                const found = response.data.find(item => item.dayOfWeek === day[0]);
                return found ? { ...found, dayLabel: day[1] } : defaultDay(branchId, day);
            }));
            onChange?.(DAYS_OF_WEEK.map(day => {
                const found = response.data.find(item => item.dayOfWeek === day[0]);
                return found ? { ...found, dayLabel: day[1] } : defaultDay(branchId, day);
            }));
        } catch (err) {
            setError(t('error_loading_data'));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { if (branchId) load(); }, [branchId]);

    const updateDay = (index, changes) => setWorkingHours(current => {
        const updated = current.map((day, i) => i === index ? { ...day, ...changes } : day);
        onChange?.(updated);
        return updated;
    });

    if (loading) return <div className="py-3 text-center"><Spinner animation="border" size="sm" /></div>;

    return (
        <Card className="border-0">
            <Card.Body className="px-0">
                {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}
                {workingHours.map((day, index) => (
                    <Card key={day.dayOfWeek} className="mb-2 border">
                        <Card.Body className="py-2">
                            <Row className="align-items-center g-2">
                                <Col xs={12} md={3}>
                                    <Form.Check type="switch" id={`branch-hours-${branchId}-${day.dayOfWeek}`}
                                        label={day.dayLabel} checked={day.isOpen}
                                        onChange={() => updateDay(index, { isOpen: !day.isOpen })} />
                                </Col>
                                {day.isOpen ? ['openTime', 'closeTime', 'breakStartTime', 'breakEndTime'].map((field, fieldIndex) => (
                                    <Col xs={6} md={2} key={field}>
                                        <Form.Label className="small text-muted mb-1">
                                            {[t('open_time'), t('close_time'), t('break_start'), t('break_end')][fieldIndex]}
                                        </Form.Label>
                                        <Form.Control type="time" size="sm" value={day[field] || ''}
                                            onChange={event => updateDay(index, { [field]: event.target.value || null })} />
                                    </Col>
                                )) : <Col><span className="text-muted">{t('closed')}</span></Col>}
                            </Row>
                        </Card.Body>
                    </Card>
                ))}
            </Card.Body>
        </Card>
    );
};

export default BranchWorkingHoursEditor;
